import { render, staticRenderFns } from "./PriceTag.vue?vue&type=template&id=2771c08d&"
import script from "./PriceTag.vue?vue&type=script&lang=js&"
export * from "./PriceTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports